import React from "react";
import { observer } from "mobx-react-lite";
import IEOMobile from "./IEOMobile";

const IEOPage = observer(() => <IEOMobile />);

export default IEOPage;
